'use client'

import React, { useEffect, useState } from 'react'
import styles from './styles.module.css'
import Text from '../../Text'
import PricingOffer from './PricingOffer'
import { useRegionSubscriptions } from '../../RegionSurfaces'
import { CircularProgress } from '@mui/material'
import BillingCycleToggle from './BillingCycleToggle'

function PricingTable({ textColor, cta, bottomText = 'You can cancel your subscription at anytime' }) {
  // Runtime CMS-driven colour -> inline style (matches former styled `${props.color}`).
  const colorStyle = { color: textColor.value }

  // Overmind→server-props (Phase A2.2): subscriptions come from the SSR-threaded
  // <RegionSurfacesProvider> (byte-identical to the store, which stays hydrated),
  // with an Overmind fallback for any non-page entry point.
  const { subscriptions, ensureRequested } = useRegionSubscriptions()

  const [showYearly, setShowYearly] = useState(true)

  useEffect(() => {
    ensureRequested()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // #418: gate the loader on THIS section's OWN data (vrsSubscriptions), NOT the
  // global state.isLoading flag. vrsSubscriptions is SSR-hydrated whenever the
  // page renders this section (buildSurfaceMutations), so it is PRESENT on the
  // client's first render — SSR and client-first render content identically. The
  // loader now shows only when the data is genuinely absent, which is the SAME on
  // SSR and client-first render. The old `if (state.isLoading)` emitted a spinner
  // into the SSR HTML whenever any OTHER section's fetch flipped the global flag
  // (the latency-only #418 cascade), even though this data was already hydrated.
  if (!subscriptions || !subscriptions.length) {
    return (
      <div className={styles.loading} style={colorStyle}>
        <CircularProgress color="inherit"/>
      </div>
    )
  }

  return (
    <div style={colorStyle}>
      <div className={styles.contentWrapper}>
        <BillingCycleToggle
          onToggle={() => setShowYearly(!showYearly)}
          toggled={showYearly}
          isLoading={false}
        />
        <div className={styles.pricingOffersWrapper}>
          { subscriptions.map((s, i) =>
            <PricingOffer
              key={s.code}
              show={true}
              title={s.name}
              subtitle={s.description}
              isMostPopular={i === (subscriptions.length - 1)}
              price={s.price}
              features={s.features}
              cta={cta}
              hasTrial={s.code === 'competitive'}
              showYearly={showYearly}
            /> ) }
        </div>
        {bottomText && <Text type="body-short-2">{bottomText}</Text>}
      </div>
    </div>
  )
}

export default PricingTable
